module.exports = __webpack_public_path__ + "img/Frame-45.a9140375.svg";